import * as React from "react";
import * as ReactDOM from "react-dom";
import { HeaderItem, HeaderMenuItem } from "../../components/header"

interface IProperties
{
    /**
     * Enthält alle Elemente die in der linken Sektion des Headers gerendert werden sollen.
     */
    leftItems?: JSX.Element | JSX.Element[],

    /**
     * Enthält alle Elemente die in der rechten Sektion des Headers gerendert werden sollen.
     */
    rightItems?: JSX.Element | JSX.Element[],

    /**
     * Enthält alle Items die in der Kalender Sektion des Headers gerendert werden sollen.
     */
    calendarItems?: JSX.Element[],

    /**
     * Wird ausgeführt, sobald auf den Menü Button geklickt wird.
     */
    onMenuClick?: (e: MouseEvent) => void
}

export class Header extends React.Component<IProperties>
{
    /**
     * Wird ausgeführt, sobald auf den Menü-Button des Headers geklickt wird.
     * @param e Das ausführende Ereignis.
     */
    private onMenuButtonClick = (e: MouseEvent) =>
    {
        this.props.onMenuClick && this.props.onMenuClick(e);
    }

    /**
     * Generiert die Sektion für die selektierten Kalender. Wird nur generiert wenn auch "CalendarItems" übergeben wurden.
     */
    private renderCalendarItems()
    {
        if (this.props.calendarItems != null && this.props.calendarItems.length > 0)
        {
            return (
                <div className="header_calendars">
                    {this.props.calendarItems}
                </div>
            );
        }

        return null;
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <header className="header_container">
                <div className="header">
                    <div className="header_section">
                        <HeaderMenuItem onClick={this.onMenuButtonClick} />
                        {this.props.leftItems}
                    </div>
                    <div className="header_section">
                        {this.props.rightItems}
                    </div>
                </div>
                {this.renderCalendarItems()}
            </header>
        );
    }
}